<template>
  <div class="stats-page">

    <!-- 1. 顶部数据概览卡片 (保持不变) -->
    <div class="summary-card">
      <div class="card-item">
        <span class="label">统计日期</span>
        <span class="value date">{{ time }}</span>
      </div>
      <div class="divider"></div>
      <div class="card-item">
        <span class="label">设备总数</span>
        <span class="value num">{{ totalCount }}</span>
      </div>
      <div class="divider"></div>
      <div class="card-item">
        <span class="label">异常数</span>
        <span class="value error">{{ errorCount }}</span>
      </div>
    </div>

    <!-- 2. 图表区域 (新增) -->
    <div class="charts-wrapper" v-if="tableData.length > 0">
      <div class="chart-box">
        <div class="chart-title">设备状态分布 (饼图)</div>
        <div ref="pieChart" class="echart-container"></div>
      </div>
      
      <div class="chart-box">
        <div class="chart-title">各校运动人次排行 (柱状图)</div>
        <div ref="barChart" class="echart-container big-height"></div>
      </div>
    </div>

    <!-- 3. 表格控制栏 (新增) -->
    <div class="table-control-bar" @click="toggleTable">
      <span>设备明细数据表格</span>
      <div class="toggle-btn">
        <span>{{ isTableExpanded ? '收起' : '展开查看' }}</span>
        <van-icon :name="isTableExpanded ? 'arrow-up' : 'arrow-down'" />
      </div>
    </div>

    <!-- 4. 表格区域 (增加 v-show 控制) -->
    <div class="table-wrapper" v-show="isTableExpanded" @touchstart="hideTip">
      <transition name="van-fade">
        <div v-if="showScrollTip" class="scroll-tip-overlay">
          <div class="tip-box">
            <van-icon name="exchange" class="anim-icon" />
            <span>左右滑动查看详情</span>
          </div>
        </div>
      </transition>

      <div class="table-scroll-container">
        <table class="sticky-table">
          <thead>
            <tr>
              <th class="sticky-col th-bg">学校名称</th>
              <th class="th-bg">产品名称</th>
              <th class="th-bg center">数量 (台)</th>
              <th class="th-bg">安装时间</th>
              <th class="th-bg right">运动 (人/次)</th>
              <th class="th-bg">异常原因</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(schoolItem, sIndex) in tableData">
              <tr 
                v-for="(prod, pIndex) in schoolItem.products" 
                :key="sIndex + '-' + pIndex"
                :class="{ 'row-warning': schoolItem.reason }"
              >
                <td v-if="pIndex === 0" :rowspan="schoolItem.products.length" class="sticky-col main-col">
                  <div class="school-name">{{ schoolItem.school }}</div>
                </td>
                <td class="content-col">
                  <div class="product-name">{{ prod.name }}</div>
                </td>
                <td class="center font-bold">{{ prod.count }}</td>
                <td v-if="pIndex === 0" :rowspan="schoolItem.products.length" class="center">
                  {{ schoolItem.installDate }}
                </td>
                <td v-if="pIndex === 0" :rowspan="schoolItem.products.length" class="right num-font">
                  {{ schoolItem.totalActivity ? formatNumber(schoolItem.totalActivity) : (schoolItem.reason ? '' : '-') }}
                </td>
                <td v-if="pIndex === 0" :rowspan="schoolItem.products.length">
                  <div class="status-box">
                    <template v-if="schoolItem.reason">
                      <div class="reason-text">
                        <van-icon name="warning" color="#ee0a24" />
                        <span>{{ schoolItem.reason }}</span>
                      </div>
                    </template>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="footer-tips">
        已展示全部 {{ tableData.length }} 所学校设备数据
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts'; // 引入 ECharts

export default {
  data() {
    return {
      showScrollTip: true,
      isTableExpanded: false, // 控制表格是否展开，默认折叠
      tableData: [],
      time: "",
      myPieChart: null,
      myBarChart: null
    };
  },
  computed: {
    totalCount() {
      return this.tableData.reduce((sum, school) => {
        return sum + school.products.reduce((pSum, p) => pSum + p.count, 0);
      }, 0);
    },
    errorCount() {
      return this.tableData
        .filter(item => item.reason)
        .reduce((sum, school) => {
          return sum + school.products.reduce((pSum, p) => pSum + p.count, 0);
        }, 0);
    },
    // 计算正常设备数用于饼图
    normalCount() {
      return this.totalCount - this.errorCount;
    }
  },
  mounted() {
    this.getTime();
    this.$toast.loading({ message: '数据同步中...', duration: 0 });
    
    // 模拟异步数据
    setTimeout(() => {
      this.showScrollTip = false;
      this.tableData = [
        { school: "通州区实验小学", installDate: "2025年1月", totalActivity: 4906, reason: "", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "南通第一初级中学", installDate: "2025年1月", totalActivity: 478, reason: "", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "泰州市城东小学", installDate: "2025年2月", totalActivity: 75, reason: "", products: [{ name: "跳跳乐园", count: 1 }] },
        { school: "江苏省射阳中学", installDate: "2025年3月", totalActivity: 77, reason: "", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "海门海南中学", installDate: "2025年3月", totalActivity: 128, reason: "", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "泗阳县实验初级中学", installDate: "2025年3月", totalActivity: null, reason: "未安装", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "江苏省淮安市周恩来红军中学东校区", installDate: "2025年3月", totalActivity: 49, reason: "", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "泰兴市实验初中", installDate: "2025年4月", totalActivity: 119, reason: "", products: [{ name: "综合体质测试仪", count: 2 }] },
        { school: "华西实验学校", installDate: "2025年5月", totalActivity: null, reason: "无外网环境，无法远程统计", products: [{ name: "跳跳乐园（室外版43寸）", count: 2 }] },
        { school: "水秀中学", installDate: "2025年8月", totalActivity: 12, reason: "", products: [{ name: "综合体质测试仪（室内版）", count: 2 }] },
        { school: "宜兴东域小学", installDate: "2025年8月", totalActivity: 2301, reason: "", products: [{ name: "跳跳乐园（室外版43寸）", count: 2 }] },
        { school: "陶都中学", installDate: "2025年8月", totalActivity: 65, reason: "", products: [{ name: "综合体质测试仪（室内版）", count: 2 }] },
        { school: "育才小学", installDate: "2025年9月", totalActivity: 5047, reason: "", products: [{ name: "跳跳乐园（室外版43寸）", count: 2 }] },
        { school: "汶河小学", installDate: "2025年9月", totalActivity: 2613, reason: "", products: [{ name: "跳跳乐园（室外版43寸）", count: 2 }] },
        { 
          school: "涟水县幸福里实验小学", 
          installDate: "2025年11月", 
          totalActivity: 36400, 
          reason: "", 
          products: [
            { name: "跳跳乐园（室外版43寸）", count: 1 },
            { name: "跳跳乐园（室内版55寸）", count: 1 },
            { name: "综合体质测试仪", count: 1 },
            { name: "50米跑", count: 1 }
          ] 
        },
        { school: "盐城市响水县实验小学", installDate: "2025年12月", totalActivity: 7, reason: "", products: [{ name: "跳跳乐园（室内版55寸）", count: 1 }] }
      ];
      
      this.$toast.clear();
      
      // 数据加载完成后初始化图表
      this.$nextTick(() => {
        this.initPieChart();
        this.initBarChart();
      });
      
    }, 1000);

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.myPieChart) this.myPieChart.dispose();
    if (this.myBarChart) this.myBarChart.dispose();
  },
  methods: {
    getTime() {
      const today = new Date();
      this.time = `${today.getFullYear()}/${today.getMonth() + 1}/${today.getDate()}`;
    },
    formatNumber(num) {
      if (num === null || num === undefined) return '';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    hideTip() {
      this.showScrollTip = false;
    },
    toggleTable() {
      this.isTableExpanded = !this.isTableExpanded;
    },
    handleResize() {
      if (this.myPieChart) this.myPieChart.resize();
      if (this.myBarChart) this.myBarChart.resize();
    },
 // 优化后的饼图初始化
    initPieChart() {
      const chartDom = this.$refs.pieChart;
      if (!chartDom) return;
      
      // 销毁旧实例防止内存泄漏
      if (this.myPieChart) this.myPieChart.dispose();
      
      this.myPieChart = echarts.init(chartDom);

      const option = {
        // 标题显示在环形图中间
        title: {
          text: this.totalCount + '台',
          subtext: '设备总数',
          left: 'center',
          top: 'center',
          textStyle: { fontSize: 20, fontWeight: 'bold', color: '#323233' },
          subtextStyle: { fontSize: 12, color: '#969799' }
        },
        tooltip: { trigger: 'item' },
        legend: { bottom: '0%', left: 'center', icon: 'circle' },
        color: ['#07c160', '#ee0a24'], // 绿色正常，红色异常
        series: [
          {
            name: '设备状态',
            type: 'pie',
            radius: ['45%', '70%'], // 调整内半径留出空间给中间文字
            center: ['50%', '45%'], // 稍微上移一点，给底部Legend留空间
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              // 格式化：名称 换行 数值(百分比)
              formatter: '{b}\n{c}台 ({d}%)',
              lineHeight: 15,
              color: '#646566' 
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10
            },
            data: [
              { value: this.normalCount, name: '正常' },
              { value: this.errorCount, name: '异常' }
            ]
          }
        ]
      };
      this.myPieChart.setOption(option);
    },

    // 优化后的柱状图初始化
    initBarChart() {
      const chartDom = this.$refs.barChart;
      if (!chartDom) return;

      if (this.myBarChart) this.myBarChart.dispose();
      this.myBarChart = echarts.init(chartDom);

      // 1. 数据处理：过滤并排序（从大到小，方便展示 Top）
      const dataCopy = [...this.tableData]
        .map(item => ({
            name: item.school,
            value: item.totalActivity || 0
        }))
        .sort((a, b) => a.value - b.value); // ECharts 默认 y 轴类目从下到上，所以这里从小到大排，图表上看起来就是从上到下递增

      const schools = dataCopy.map(i => i.name);
      const values = dataCopy.map(i => i.value);

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: '{b}<br/>运动人次：{c}' // Tooltip 显示完整名称
        },
        grid: {
          left: '3%',
          right: '12%', // 右侧留多一点给数值标签
          bottom: '3%',
          top: '2%',
          containLabel: true // 自动计算坐标轴宽度
        },
        xAxis: {
          type: 'value',
          position: 'top', // X轴刻度放上面，或者不显示
          splitLine: { show: false }, // 去掉网格线更清爽
          axisLabel: { show: false } // 隐藏底部数字，因为柱子旁边会显示
        },
        yAxis: {
          type: 'category',
          data: schools,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            interval: 0,
            margin: 10,
            color: '#323233',
            formatter: function (value) {
              // 核心优化：名称过长截断，超过 6 个字显示省略号
              if (value.length > 6) {
                return value.substring(0, 6) + '...';
              }
              return value;
            }
          }
        },
        series: [
          {
            name: '运动人次',
            type: 'bar',
            data: values,
            barWidth: 16, // 柱子细一点，看起来更精致
            barMinHeight: 2, // 保证数值极小时也能看到一点点柱子
            itemStyle: {
              borderRadius: [0, 10, 10, 0], // 右边圆角
              // 渐变色优化，看起来更高级
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ])
            },
            label: {
              show: true,
              position: 'right', // 数值放在右侧
              color: '#333',
              fontWeight: 'bold',
              formatter: (params) => {
                  // 数字千分位格式化
                  return params.value > 0 ? params.value.toLocaleString() : '';
              }
            }
          }
        ]
      };
      this.myBarChart.setOption(option);
    }
  }
};
</script>

<style lang="less" scoped>
@primary-color: #1989fa;
@danger-color: #ee0a24;
@warning-bg: #fff4f4;
@text-main: #323233;
@text-regular: #646566;
@border-color: #ebedf0;
@white: #ffffff;

.stats-page { min-height: 100vh; background-color: #f7f8fa; padding-bottom: 20px; }

/* 概览卡片样式 */
.summary-card {
  margin: 12px; background: @white; border-radius: 8px; padding: 16px 0;
  display: flex; align-items: center; justify-content: space-evenly;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
  .divider { width: 1px; height: 24px; background-color: @border-color; }
  .card-item {
    display: flex; flex-direction: column; align-items: center;
    .label { font-size: 12px; color: #969799; margin-bottom: 6px; }
    .value { font-size: 16px; font-weight: 600; color: @text-main;
      &.num, &.date, &.error { font-family: 'DIN Alternate', sans-serif; }
      &.date { color: @primary-color; }
      &.error { color: @danger-color; font-size: 20px; }
    }
  }
}

/* 图表区域样式 */
.charts-wrapper {
  margin: 12px;
  .chart-box {
    background: @white;
    border-radius: 8px;
    padding: 16px 10px; /* 减少左右内边距，给图表更多空间 */
    margin-bottom: 12px;
    
    /* 增加标题样式 */
    .chart-title {
      font-size: 15px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
      padding-left: 10px;
      border-left: 4px solid @primary-color;
    }

    .echart-container {
      width: 100%;
      height: 280px; /* 饼图高度 */
      
      &.big-height {
        /* 
           动态计算高度：
           基础高度 50px + (学校数量 * 40px)
           防止数量少时留白太多，数量多时挤压
        */
        height: 600px; 
      }
    }
  }
}

/* 表格控制栏样式 */
.table-control-bar {
  margin: 12px;
  padding: 12px 16px;
  background: @white;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: @text-main;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
  cursor: pointer;

  .toggle-btn {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: @primary-color;
    font-weight: normal;
    span { margin-right: 4px; }
  }
  
  &:active {
    background-color: #f2f3f5;
  }
}

/* 表格区域样式 */
.table-wrapper {
  position: relative; margin-top: 0; background: @white;
  margin: 0 12px 12px 12px; /* 配合上方按钮对齐 */
  border-radius: 8px;
  overflow: hidden;
  .table-scroll-container { overflow-x: auto; -webkit-overflow-scrolling: touch; }
}

.sticky-table {
  width: 100%; border-collapse: separate; border-spacing: 0;
  th, td {
    padding: 12px 10px; border-bottom: 1px solid @border-color; border-right: 1px solid @border-color;
    white-space: nowrap; font-size: 13px; vertical-align: middle;
  }
  th { background-color: #fafafa; color: @text-regular; font-weight: 500; text-align: left; }
  
  .sticky-col {
    position: sticky; left: 0; z-index: 2; background-color: @white;
    &::after {
      content: ''; position: absolute; top: 0; right: -1px; bottom: 0; width: 1px; background: @border-color;
    }
  }

  .row-warning {
    td { background-color: @warning-bg; }
    .sticky-col { background-color: @warning-bg !important; }
    .reason-text { color: @danger-color; font-size: 12px; display: flex; align-items: center; white-space: normal; min-width: 100px; }
  }

  .school-name { font-weight: bold; width: 120px; white-space: normal; line-height: 1.4; word-break: break-all; }
  .product-name { color: @text-regular; font-size: 12px; white-space: normal; min-width: 120px; }
  .center { text-align: center; }
  .right { text-align: right; }
  .num-font { font-family: 'DIN Alternate', sans-serif; font-weight: 600; }
  
  .status-box {
    .dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; margin-right: 6px; background-color: #07c160; }
    .status-text { color: @text-regular; font-size: 12px; }
  }
}

.scroll-tip-overlay {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 20;
  background: rgba(255,255,255,0.2); backdrop-filter: blur(1px);
  display: flex; justify-content: center; align-items: center; pointer-events: none;
  .tip-box {
    background: rgba(0,0,0,0.65); color: @white; padding: 8px 16px; border-radius: 20px; font-size: 12px;
    .anim-icon { margin-right: 6px; animation: pulse 1.5s infinite; }
  }
}

.footer-tips { text-align: center; color: #c8c9cc; font-size: 12px; padding: 24px 0; }
@keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.1); } 100% { transform: scale(1); } }
</style>
